import { BlogArticlePage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/blog/$slug")({
  component: OperatorBlogArticle,
});

function OperatorBlogArticle() {
  const { slug } = Route.useParams();
  return (
    <BlogArticlePage portal="operator" basePath="/operator/blog" slug={slug} />
  );
}
